import { useTranslation } from "react-i18next";
import { formatCurrency } from "@/lib/format";
import { SectionShell } from "@/components/therapist/settings/section-primitives";
import { StatCard, SessionPayoutList, type PayoutSessionRow } from "@/components/therapist/finances/FinanceRows";
import { PayoutRequestPanel } from "@/components/therapist/finances/PayoutRequestPanel";

export function PayoutsTab({
  summary,
  sessions,
  isFetching,
}: {
  summary: { totalEarnings: number; pendingPayout: number; paidOut: number; unresolvedCount?: number };
  sessions: PayoutSessionRow[];
  isFetching: boolean;
}) {
  const { t } = useTranslation();
  return (
    <>
      <section className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <StatCard label={t("therapist.earnings.totalEarnings")} value={formatCurrency(summary.totalEarnings)} tone="primary" />
        <StatCard label={t("therapist.earnings.pendingPayout")} value={formatCurrency(summary.pendingPayout)} tone="pending" />
        <StatCard label={t("therapist.earnings.paidOut")} value={formatCurrency(summary.paidOut)} tone="paid" />
      </section>

      {(summary.unresolvedCount ?? 0) > 0 && (
        <p className="rounded-xl bg-amber-50 px-4 py-3 text-sm text-amber-900 ring-1 ring-amber-200">
          {t("therapist.earnings.unresolvedEarnings", { count: summary.unresolvedCount })}
        </p>
      )}

      <PayoutRequestPanel />

      <SectionShell
        title={t("therapist.finances.payouts")}
        description={t("therapist.finances.payoutsDesc", { count: sessions.length })}
      >
        <SessionPayoutList
          sessions={sessions}
          isFetching={isFetching}
          emptyLabel={t("therapist.finances.noPayouts")}
          statusLabels={{
            paid: t("therapist.finances.statusPaid"),
            pending: t("therapist.finances.statusPending"),
            unpaid: t("therapist.finances.statusUnpaid"),
          }}
        />
      </SectionShell>
    </>
  );
}
